import { runClientComponent } from '../../_common/client/client-component-runner';
import { BetterShippingAlternativeComponent } from './better-shipping-alternative.component';

runClientComponent({ BetterShippingAlternativeComponent: BetterShippingAlternativeComponent });
